import React, { useState, ReactNode, KeyboardEvent, FC } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { TooltipLoader } from '../../global/TooltipLoader';
import styles from './main.scss';
import { useUID } from 'dibs-uid';

import { TooltipProps } from 'dibs-elements/src/Tooltip';

type Props = {
    tooltipContent: ReactNode;
    dataTn?: string;
    wrapperClass?: string;
    linkClass?: string;
    ariaLabel?: string;
} & Pick<TooltipProps, 'align' | 'direction' | 'paddingSize'>;

const ESC = 'Escape';

export const SharedTooltip: FC<Props> = ({
    tooltipContent,
    dataTn,
    children,
    direction,
    align,
    paddingSize,
    wrapperClass,
    linkClass,
    ariaLabel,
}) => {
    // TODO move into  new TooltipContainer component or create useTooltipTrigger hook
    const uid = useUID() || undefined;
    const [isVisible, setIsVisible] = useState(false);
    const [load, setLoad] = useState(false);

    // keyboard-focused tooltips should close when blurred or when [Esc] is pressed
    function handleEsc(e: KeyboardEvent): void {
        if (e.key === ESC) {
            setIsVisible(false);
        }
    }

    function handleOpen(): void {
        setIsVisible(true);
        setLoad(true);
    }

    if (!children) {
        return null;
    }
    return (
        <div
            // attach mouse listeners to tooltip parent to keep tooltip open when moving
            // mouse to the absolutely positioned tooltip
            onMouseEnter={handleOpen}
            onMouseLeave={() => setIsVisible(false)}
            className={classnames(styles.wrapper, wrapperClass)}
            data-tn={dataTn}
        >
            <Link
                className={classnames(styles.tooltipTrigger, linkClass)}
                underline="none"
                ariaLabel={ariaLabel}
                ariaHasPopup
                dataTn={dataTn}
                ariaDescribedBy={uid}
                onClick={() => {}}
                onKeyDown={handleEsc}
                onFocus={handleOpen}
                onBlur={() => setIsVisible(false)}
            >
                {children}
            </Link>
            <span id={uid} hidden>
                {tooltipContent}
            </span>
            <TooltipLoader
                load={load}
                isVisible={isVisible}
                direction={direction}
                align={align}
                paddingSize={paddingSize}
            >
                {tooltipContent}
            </TooltipLoader>
        </div>
    );
};
